<mbs-modal
  [loading]="loading"
  [title]="'wizards:addNetworkShare' | i18next: { format: 'title' }">
  <ng-container
    modal-body
    [formGroup]="form">
    <div
      *ngIf="viewMode === networkShareViewMode.form"
      [attr.data-e2e]="elementsSelector.name.formBlock">
      <mbs-button
        *ngIf="networkSharePathArray?.length"
        class="mb-3"
        [attr.data-e2e]="elementsSelector.name.backButton"
        [disabled]="loading || credentialsLoading"
        [isCtrl]="true"
        (click)="backToListClickHandler()">
        <span class="fa fa-arrow-left"></span>
        {{ 'wizards:addNetworkShareBack' | i18next }}
      </mbs-button>

      <mbs-form-group>
        <mbs-input
          formControlName="path"
          name="newPath"
          [id]="'new-path-input-1'"
          [label]="'wizards:addNetworkSharePath' | i18next"
          [placeholder]="'wizards:addNetworkSharePathPlaceholder' | i18next"
          [validationWhitespace]="true"
          (input)="resetTestResult()"></mbs-input>
      </mbs-form-group>

      <div class="form-row mb-3">
        <div class="col-6">
          <mbs-input
            formControlName="login"
            name="login"
            [id]="'login-input'"
            [label]="'wizards:addNetworkShareLogin' | i18next"
            [placeholder]="'wizards:addNetworkShareLoginPlaceholder' | i18next"
            [validationWhitespace]="true"
            (input)="resetTestResult()"></mbs-input>
        </div>
        <div class="col-6">
          <mbs-input-password
            formControlName="password"
            [boldLabel]="true"
            [id]="'add-network-share-password-input'"
            [label]="'wizards:addNetworkSharePass' | i18next"
            [placeholder]="'wizards:addNetworkSharePassPlaceholder' | i18next"
            (input)="resetTestResult()"></mbs-input-password>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <mbs-button
          [loading]="credentialsLoading"
          [size]="size.sm"
          [type]="'secondary'"
          (click)="testClickHandler()"
          >{{ 'wizards:addNetworkShareTest' | i18next: { format: 'title' } }}</mbs-button
        >

        <mbs-alert
          *ngIf="testResult === checkCredentialsResultEnum.Success"
          class="mb-0 ml-3"
          [attr.data-e2e]="elementsSelector.name.successAlert"
          [icon]="true"
          [size]="size.sm"
          [type]="mbsPopupType.success">
          {{ 'wizards:addNetworkShareSuccess' | i18next }}
        </mbs-alert>

        <mbs-alert
          *ngIf="testResult === checkCredentialsResultEnum.Error"
          class="mb-0 ml-3"
          [attr.data-e2e]="elementsSelector.name.errorAlert"
          [icon]="true"
          [size]="size.sm"
          [type]="mbsPopupType.danger">
          {{ 'wizards:addNetworkShareError' | i18next }}
        </mbs-alert>
      </div>
    </div>

    <div
      *ngIf="viewMode === networkShareViewMode.list"
      [attr.data-e2e]="elementsSelector.name.listBlock">
      <mbs-list-select
        id="network-share-list-table"
        listType="table"
        [data]="networkSharePathArray"
        [headers]="headers"
        [loadSource]="false"
        [maxHeight]="'280px'"
        [noDataMessage]="'wizards:where_backup_no_data' | i18next"
        [showCheckboxes]="false"
        [showHeaders]="true"
        [showSearch]="false">
        <ng-template
          let-item
          mbsTableCell
          >{{ item.path }}</ng-template
        >
        <ng-template
          let-item
          mbsTableCell
          >{{ item.login || '-' }}</ng-template
        >
        <ng-template
          let-item
          mbsTableCell>
          <mbs-group-button>
            <mbs-button
              [icon]="'fa fa-pencil'"
              [size]="size.sm"
              [type]="'secondary'"
              (click)="editItemClickHandler(item)"></mbs-button>
            <mbs-button
              [icon]="'fa fa-trash'"
              [size]="size.sm"
              [type]="'secondary'"
              (click)="deleteItemClickHandler(item)"></mbs-button>
          </mbs-group-button>
        </ng-template>
      </mbs-list-select>

      <mbs-button
        class="mt-3"
        [block]="true"
        [type]="'secondary'"
        (click)="addNewPathClickHandler()">
        {{ 'wizards:addNetworkShareAdd' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>
  </ng-container>

  <ng-container modalFooter>
    <button
      *ngIf="editPath"
      class="btn btn-primary"
      type="button"
      [attr.data-e2e]="elementsSelector.name.listBlockButton"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next: { format: 'title' } }}
    </button>
    <button
      *ngIf="!editPath && viewMode === networkShareViewMode.form"
      class="btn btn-primary"
      type="button"
      [attr.data-e2e]="elementsSelector.name.formBlockButton"
      (click)="addClickHandler()">
      {{ 'shared:buttons.add' | i18next: { format: 'title' } }}
    </button>
    <button
      class="btn btn-secondary"
      data-dismiss="modal"
      type="button"
      (click)="cancelClickHandler()">
      {{
        editPath || viewMode === networkShareViewMode.form
          ? ('shared:buttons.cancel' | i18next: { format: 'title' })
          : ('shared:buttons.close' | i18next: { format: 'title' })
      }}
    </button>
  </ng-container>
</mbs-modal>
